import GalleryItem from './GalleryItem'

import acter1 from '../assets/img/home/acter1.png'
import acter2 from '../assets/img/home/acter2.png'
import actress from '../assets/img/home/actress.png'


const data = [
    { id: 2, flex: 1, speaker: { name: 'Speaker Name' }, img: acter1, message: 'Lorem ipsum dolor sit amet, consectetur adipiscing  elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
    { id: 1, flex: 2, speaker: { name: 'Speaker Name' }, img: actress, message: 'Lorem ipsum dolor sit amet, consectetur adipiscing  elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
    { id: 3, flex: 2, speaker: { name: 'Speaker Name' }, img: acter2, message: 'Lorem ipsum dolor sit amet, consectetur adipiscing  elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
]

const Gallery = () => {
    return (
        <div className="gallery">
            {data.map((item, index) => (
                <GalleryItem item={item} key={`gallery-${index}`}/>
            ))}
        </div>
    )
}
export default Gallery